/**
 * Event schema — mirrors backend analytics/schema.go.
 * Maps event names to their required consent tier.
 */

export const ConsentTier = {
  ESSENTIAL: 0,
  ANALYTICS: 1,
  ENHANCED: 2,
};

const EVENT_TIERS = {
  // Tier 0: Essential (always on, no consent)
  js_error: ConsentTier.ESSENTIAL,
  api_error: ConsentTier.ESSENTIAL,
  web_vitals: ConsentTier.ESSENTIAL,
  consultation_quality: ConsentTier.ESSENTIAL,
  session_cleanup_ran: ConsentTier.ESSENTIAL,
  fraud_signal_detected: ConsentTier.ESSENTIAL,
  ledger_reconciliation: ConsentTier.ESSENTIAL,
  deployment_started: ConsentTier.ESSENTIAL,
  deployment_completed: ConsentTier.ESSENTIAL,
  consent_granted: ConsentTier.ESSENTIAL,
  consent_withdrawn: ConsentTier.ESSENTIAL,

  // Tier 1: Analytics (requires opt-in)
  page_view: ConsentTier.ANALYTICS,
  page_time: ConsentTier.ANALYTICS,
  scroll_depth: ConsentTier.ANALYTICS,
  session_start: ConsentTier.ANALYTICS,
  session_end: ConsentTier.ANALYTICS,
  user_registered: ConsentTier.ANALYTICS,
  user_logged_in: ConsentTier.ANALYTICS,
  user_logged_out: ConsentTier.ANALYTICS,
  signup_completed: ConsentTier.ANALYTICS,
  profile_completed: ConsentTier.ANALYTICS,
  astrologer_viewed: ConsentTier.ANALYTICS,
  astrologer_filtered: ConsentTier.ANALYTICS,
  kundli_started: ConsentTier.ANALYTICS,
  kundli_completed: ConsentTier.ANALYTICS,
  horoscope_viewed: ConsentTier.ANALYTICS,
  kalasakthi_viewed: ConsentTier.ANALYTICS,
  astrologer_search: ConsentTier.ANALYTICS,
  chat_opened: ConsentTier.ANALYTICS,
  review_submitted: ConsentTier.ANALYTICS,
  search_performed: ConsentTier.ANALYTICS,
  language_switched: ConsentTier.ANALYTICS,
  notification_clicked: ConsentTier.ANALYTICS,
  consultation_initiated: ConsentTier.ANALYTICS,
  consultation_started: ConsentTier.ANALYTICS,
  consultation_accepted: ConsentTier.ANALYTICS,
  consultation_rejected: ConsentTier.ANALYTICS,
  consultation_message_sent: ConsentTier.ANALYTICS,
  consultation_ended: ConsentTier.ANALYTICS,
  consultation_rated: ConsentTier.ANALYTICS,
  booking_started: ConsentTier.ANALYTICS,
  booking_slot_selected: ConsentTier.ANALYTICS,
  booking_completed: ConsentTier.ANALYTICS,
  booking_abandoned: ConsentTier.ANALYTICS,
  slot_booked: ConsentTier.ANALYTICS,
  payment_initiated: ConsentTier.ANALYTICS,
  payment_completed: ConsentTier.ANALYTICS,
  payment_failed: ConsentTier.ANALYTICS,
  wallet_recharge_initiated: ConsentTier.ANALYTICS,
  wallet_recharge_completed: ConsentTier.ANALYTICS,
  wallet_recharge_failed: ConsentTier.ANALYTICS,
  billing_tick: ConsentTier.ANALYTICS,
  low_balance_warning: ConsentTier.ANALYTICS,
  payout_requested: ConsentTier.ANALYTICS,
  payout_approved: ConsentTier.ANALYTICS,
  refund_initiated: ConsentTier.ANALYTICS,
  refund_completed: ConsentTier.ANALYTICS,
  recommendation_shown: ConsentTier.ANALYTICS,
  recommendation_clicked: ConsentTier.ANALYTICS,
  recommendation_booked: ConsentTier.ANALYTICS,

  // Tier 2: Enhanced (explicit opt-in)
  session_replay_start: ConsentTier.ENHANCED,
  heatmap_click: ConsentTier.ENHANCED,
};

export function getEventTier(eventName) {
  return EVENT_TIERS[eventName] ?? ConsentTier.ANALYTICS;
}

export function isValidEvent(eventName) {
  return eventName in EVENT_TIERS;
}
